// extracted by mini-css-extract-plugin
module.exports = {"footerBox":"footerBox__2drW5","warning":"warning__-Boy5","footer":"footer__2Pl1_","info":"info__3i9Vq","logo":"logo__11F2u","name":"name__3nT8W","about":"about__2yZUT"};